import React from "react";
import { Warning, WarningCircle, Info } from "@phosphor-icons/react";

const levelStyle = {
  CRITICAL: { color: "#EF4444", bg: "bg-red-500/10", border: "border-red-500/30", icon: WarningCircle },
  HIGH: { color: "#F59E0B", bg: "bg-amber-500/10", border: "border-amber-500/30", icon: Warning },
  MEDIUM: { color: "#3EB6F0", bg: "bg-sky-500/10", border: "border-sky-500/30", icon: Info },
};

export default function AlertsPanel({ alerts }) {
  return (
    <div className="bg-[#111827] border border-slate-800 rounded-lg h-full flex flex-col" data-testid="alerts-panel">
      <div className="px-5 py-4 border-b border-slate-800 flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Allarmi Live</div>
          <div className="font-heading text-lg text-white">Anomaly Detection</div>
        </div>
        <div className="font-mono text-xs px-2 py-1 rounded bg-slate-800 text-slate-300">{alerts.length}</div>
      </div>
      <div className="flex-1 overflow-y-auto p-3 space-y-2 max-h-[420px]">
        {alerts.length === 0 && (
          <div className="text-center py-10 text-sm text-slate-500 font-mono">Nessuna anomalia rilevata</div>
        )}
        {alerts.map((a, i) => {
          const s = levelStyle[a.livello] || levelStyle.MEDIUM;
          const Icon = s.icon;
          return (
            <div key={i} className={`border ${s.border} ${s.bg} rounded-md p-3`} data-testid={`alert-item-${i}`}>
              <div className="flex items-start gap-3">
                <Icon size={18} weight="fill" style={{ color: s.color }} className="mt-0.5 flex-shrink-0" />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-mono text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded" style={{ color: s.color, background: s.color + "22" }}>{a.livello}</span>
                    <span className="text-xs font-mono text-slate-400">{a.tipo}</span>
                  </div>
                  <div className="text-sm text-slate-200 leading-snug">{a.messaggio}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
